import type { DehydratedState, VueQueryPluginOptions } from "@tanstack/vue-query";
import { VueQueryPlugin, QueryClient, hydrate, dehydrate } from "@tanstack/vue-query";
// Nuxt 3 app aliases
import { defineNuxtPlugin, useState } from "#imports";

export default defineNuxtPlugin((nuxt) => {
	const vueQueryState = useState<DehydratedState | null>("vue-query");

	// Modify your Vue Query global settings here
	const queryClient = new QueryClient({
		defaultOptions: { queries: { staleTime: 5 * (60 * 1000), gcTime: 6 * (60 * 1000) } },
	});
	const options: VueQueryPluginOptions = { queryClient };

	nuxt.vueApp.use(VueQueryPlugin, options);

	if (process.server) {
		nuxt.hooks.hook("app:rendered", () => {
			vueQueryState.value = dehydrate(queryClient);
		});
	}

	if (process.client) {
		nuxt.hooks.hook("app:created", () => {
			// This app runs with ssr: false, so the process.server branch above
			// never runs and vueQueryState.value is always null — hydrate() only
			// makes sense when there's an actual dehydrated state to read from.
			if (vueQueryState.value) {
				hydrate(queryClient, vueQueryState.value);
			}
		});
	}
});
